import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LoginEN from '@locales/en/login.json';
import LoginID from '@locales/id/login.json';
import dashboardEN from '@locales/en/dashboard.json';
import dashboardID from '@locales/id/dashboard.json';
import navigationEN from '@locales/en/navigation.json';
import testinputEN from '@locales/en/testInput.json';
import navigationID from '@locales/id/navigation.json';
import registerEN from '@locales/en/register.json';
import registerID from '@locales/id/register.json';

import qaQcQuestionnaireEN from '@locales/en/qa-qc-questionnaire.json';
import qaQcQuestionnaireID from '@locales/id/qa-qc-questionnaire.json';

import hseQuestionnaireEN from '@locales/en/hse-questionnaire.json';
import hseQuestionnaireID from '@locales/id/hse-questionnaire.json';

import testTableEN from '@locales/en/testtable.json';
import testTableID from '@locales/id/testtable.json';

import tableEN from '@locales/en/table.json';
import tableID from '@locales/id/table.json';

import generalInformationEN from '@locales/en/general-information/general-information.json';
import generalInformationID from '@locales/id/general-information/general-information.json';

import vendorHeaderEN from '@locales/en/vendor-header.json';
import vendorHeaderID from '@locales/id/vendor-header.json';

import notificationsEN from '@locales/en/notifications.json';
import notificationsID from '@locales/id/notifications.json';

import generalMessageEN from '@locales/en/general-message.json';
import generalMessageID from '@locales/id/general-message.json';

import formEN from '@locales/en/form.json';
import formID from '@locales/id/form.json';

import partnerCandidateID from '@locales/id/internal/partner-management/partner-candidate.json';
import partnerCandidateEN from '@locales/en/internal/partner-management/partner-candidate.json';

import propertyPersonnelID from '@locales/id/general-pq/property-and-personnel-data.json';
import propertyPersonnelEN from '@locales/en/general-pq/property-and-personnel-data.json';

import companyEN from '@locales/en/company.json';
import companyID from '@locales/id/company.json';


import additionalDocumentEN from '@locales/en/general-pq/additional-document.json';
import additionalDocumentID from '@locales/id/general-pq/additional-document.json';

import experienceDataEN from '@locales/en/general-pq/experience-data.json';
import experienceDataID from '@locales/id/general-pq/experience-data.json';
import scoringEN from '@locales/en/internal/general-pq/scoring.json';
import scoringID from '@locales/id/internal/general-pq/scoring.json';

import vmcfTab1EN from '@locales/en/internal/partner-master-creation-form/vmcf-tab1.json';
import vmcfTab1ID from '@locales/id/internal/partner-master-creation-form/vmcf-tab1.json';
import vmcfTab2EN from '@locales/en/internal/partner-master-creation-form/vmcf-tab2.json';
import vmcfTab2ID from '@locales/id/internal/partner-master-creation-form/vmcf-tab2.json';
import vmcfTab3EN from '@locales/en/internal/partner-master-creation-form/vmcf-tab3.json';
import vmcfTab3ID from '@locales/id/internal/partner-master-creation-form/vmcf-tab3.json';
import vmcfTab4EN from '@locales/en/internal/partner-master-creation-form/vmcf-tab4.json';
import vmcfTab4ID from '@locales/id/internal/partner-master-creation-form/vmcf-tab4.json';

import bankDetailsEN from '@locales/en/general-information/bank-details.json';
import bankDetailsID from '@locales/id/general-information/bank-details.json';

import financialEN from '@locales/en/financial.json';
import financialID from '@locales/id/financial.json';

import declarationsEN from '@locales/en/general-information/declarations.json';
import declarationsID from '@locales/id/general-information/declarations.json';

import blastEmailEN from '@locales/en/internal/blast-email/blast-email.json';
import blastEmailID from '@locales/id/internal/blast-email/blast-email.json';

import expertiseQualificationEN from '@locales/en/general-pq/expertise-qualification.json';
import expertiseQualificationID from '@locales/id/general-pq/expertise-qualification.json';

import invitationNewPartnerEN from '@locales/en/internal/partner-management/partner-invitation-and-monitoring.json';
import invitationNewPartnerID from '@locales/id/internal/partner-management/partner-invitation-and-monitoring.json';

import applyExpertiseEN from '@locales/en/expertise-qualification/apply-expertise.json';
import applyExpertiseID from '@locales/id/expertise-qualification/apply-expertise.json';
import recapitulationPQEN from '@locales/en/general-pq/recapitulation-pq.json';
import recapitulationPQID from '@locales/id/general-pq/recapitulation-pq.json';

import expertiseQuestionnaireManagementEN from '@locales/en/internal/partner-management/expertise-qualification/expertise-questionnaire-management.json';
import expertiseQuestionnaireManagementID from '@locales/id/internal/partner-management/expertise-qualification/expertise-questionnaire-management.json';
import bidLineItemsEN from '@locales/en/internal/inquiry-management/bid-line-items.json';
import bidLineItemsID from '@locales/id/internal/inquiry-management/bid-line-items.json';
import bidControlEN from '@locales/en/internal/inquiry-management/bid-control.json';
import bidControlID from '@locales/id/internal/inquiry-management/bid-control.json';

import attachmentsEN from '@locales/en/internal/inquiry-management/attachments.json';
import attachmentsID from '@locales/id/internal/inquiry-management/attachments.json';

import bidTeamEN from '@locales/en/internal/inquiry-management/bid-team.json';
import bidTeamID from '@locales/id/internal/inquiry-management/bid-team.json';
import bidderListEN from '@locales/en/internal/inquiry-management/bidder-list.json';
import bidderListID from '@locales/id/internal/inquiry-management/bidder-list.json';
import activeTenderInternalEN from '@locales/en/internal/inquiry-management/active-tender.json';
import activeTenderInternalID from '@locales/id/internal/inquiry-management/active-tender.json';
import generalStatusPREN from '@locales/en/internal/inquiry-management/general-status-pr.json';
import generalStatusPRID from '@locales/id/internal/inquiry-management/general-status-pr.json';

import partnerInquiryManagementEN from '@locales/en/partner-inquiry-management/partner-inquiry-management.json'
import partnerInquiryManagementID from '@locales/id/partner-inquiry-management/partner-inquiry-management.json'
import partnerInquiryManagementDownloadDocEN from '@locales/en/partner-inquiry-management/download-doc.json'
import partnerInquiryManagementDownloadDocID from '@locales/id/partner-inquiry-management/download-doc.json'
import partnerInquiryManagementParticipationConfirmEN from '@locales/en/partner-inquiry-management/participation-confirm.json'
import partnerInquiryManagementParticipationConfirmID from '@locales/id/partner-inquiry-management/participation-confirm.json'
import mandatoryChecksEN from '@locales/en/partner-inquiry-management/mandatory-check.json'
import mandatoryChecksID from '@locales/id/partner-inquiry-management/mandatory-check.json'
import offerSubmissionEN from '@locales/en/partner-inquiry-management/offer-submission.json'
import offerSubmissionID from '@locales/id/partner-inquiry-management/offer-submission.json'
import purchaseOrderEN from '@locales/en/partner-inquiry-management/purchase-order.json'
import purchaseOrderID from '@locales/id/partner-inquiry-management/purchase-order.json'

import offerSubmissionSummaryEN from '@locales/en/partner-inquiry-management/offer-submission-summary.json'
import offerSubmissionSummaryID from '@locales/id/partner-inquiry-management/offer-submission-summary.json'
import negotiationEN from '@locales/en/partner-inquiry-management/negotiation.json'
import negotiationID from '@locales/id/partner-inquiry-management/negotiation.json'
import bidResultEN from '@locales/en/partner-inquiry-management/bid-result.json'
import bidResultID from '@locales/id/partner-inquiry-management/bid-result.json'

import detailTenderEN from '@locales/en/internal/inquiry-management/detail-tender.json'
import detailTenderID from '@locales/id/internal/inquiry-management/detail-tender.json'

import inquiryHeaderEN from '@locales/en/inquiry-header.json'
import inquiryHeaderID from '@locales/id/inquiry-header.json'

import clarificationFormEN from '@locales/en/partner-inquiry-management/clarification-form.json'
import clarificationFormID from '@locales/id/partner-inquiry-management/clarification-form.json'

import cbeManagementDraftingEN from '@locales/en/internal/inquiry-management/cbe-management-drafting.json'
import cbeManagementDraftingID from '@locales/id/internal/inquiry-management/cbe-management-drafting.json'

import negotiationInternalEN from '@locales/en/internal/inquiry-management/negotiation.json'
import negotiationInternalID from '@locales/id/internal/inquiry-management/negotiation.json'

import chatEN from '@locales/en/chat.json'
import chatID from '@locales/id/chat.json'

import cbeManagementApprovalEN from '@locales/en/internal/inquiry-management/cbe-management-approval.json'
import cbeManagementApprovalID from '@locales/id/internal/inquiry-management/cbe-management-approval.json'
import negotiationBidderCaseEN from '@locales/en/internal/inquiry-management/negotiation-bidder-case.json'
import negotiationBidderCaseID from '@locales/id/internal/inquiry-management/negotiation-bidder-case.json'

import techOfferAdmEN from '@locales/en/internal/inquiry-management/tech-offer-adm-bidder-case.json'
import techOfferAdmID from '@locales/id/internal/inquiry-management/tech-offer-adm-bidder-case.json'

import poListEN from '@locales/en/internal/inquiry-management/po-list-bidder-case.json'
import poListID from '@locales/id/internal/inquiry-management/po-list-bidder-case.json'

import commOfferAdmEN from '@locales/en/internal/inquiry-management/comm-offer-adm-bidder-case.json'
import commOfferAdmID from '@locales/id/internal/inquiry-management/comm-offer-adm-bidder-case.json'

import settingDoctEN from '@locales/en/setting-documents.json'
import settingDoctID from '@locales/id/setting-documents.json'

import tbeManagementEN from '@locales/en/internal/inquiry-management/tbe-management.json'
import tbeManagementID from '@locales/id/internal/inquiry-management/tbe-management.json'

import userManagementEN from '@locales/en/user-management.json'
import userManagementID from '@locales/id/user-management.json'

import pageSettingEN from '@locales/en/page-setting.json'
import pageSettingID from '@locales/id/page-setting.json'

import newsSettingEN from '@locales/en/internal/setting/news.json'
import newsSettingID from '@locales/id/internal/setting/news.json'

import msProjectNameEN from '@locales/en/ms-project-name.json'
import msProjectNameID from '@locales/id/ms-project-name.json'

import createPoScaEN from '@locales/en/internal/po-and-contract-management/create-po-and-sca.json'
import createPoScaID from '@locales/id/internal/po-and-contract-management/create-po-and-sca.json'

import listPoScaEN from '@locales/en/internal/po-and-contract-management/list-po-and-sca.json'
import listPoScaID from '@locales/id/internal/po-and-contract-management/list-po-and-sca.json'

import partnerListID from '@locales/id/internal/partner-management/partner-list.json';
import partnerListEN from '@locales/en/internal/partner-management/partner-list.json';

import vpeID from '@locales/id/internal/partner-management/vendor-performance-evaluation.json';
import vpeEN from '@locales/en/internal/partner-management/vendor-performance-evaluation.json';

import masterDataRFQEN from '@locales/en/internal/inquiry-management/master-data-rfq.json'
import masterDataRFQID from '@locales/id/internal/inquiry-management/master-data-rfq.json'

import tenderHistoryID from '@locales/id/tender-history.json';
import tenderHistoryEN from '@locales/en/tender-history.json';

import faqID from '@locales/id/faq.json';
import faqEN from '@locales/en/faq.json';

import locanContentEN from '@locales/en/internal/inquiry-management/local-content.json';
import locanContentID from '@locales/id/internal/inquiry-management/local-content.json';
// TODO: Remove all test* references

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        login: LoginEN,
        dashboard: dashboardEN,
        navigation: navigationEN,
        testInput: testinputEN,
        testTable: testTableEN,
        register: registerEN,
        testTestTable: testTableEN,
        generalInformation: generalInformationEN,
        vendorHeader: vendorHeaderEN,
        notifications: notificationsEN,
        generalMessage: generalMessageEN,
        companyDoc: companyEN,
        qaQcQuestionnaire: qaQcQuestionnaireEN,
        form: formEN,
        financial: financialEN,
        hseQuestionnaire: hseQuestionnaireEN,
        partnerCandidate: partnerCandidateEN,
        propertyPersonnel: propertyPersonnelEN,
        bankDetails: bankDetailsEN,
        additionalDocument: additionalDocumentEN,
        experienceData: experienceDataEN,
        scoring: scoringEN,
        vmcfTab1: vmcfTab1EN,
        vmcfTab2: vmcfTab2EN,
        vmcfTab3: vmcfTab3EN,
        blastEmail: blastEmailEN,
        expertiseQualification: expertiseQualificationEN,
        vmcfTab4: vmcfTab4EN,
        declarations: declarationsEN,
        invitationNewPartner: invitationNewPartnerEN,
        applyExpertise: applyExpertiseEN,
        recapitulationPQ: recapitulationPQEN,
        expertiseQuestionnaireManagement: expertiseQuestionnaireManagementEN,
        bidLineItems: bidLineItemsEN,
        attachments: attachmentsEN,
        table: tableEN,
        bidTeams: bidTeamEN,
        bidderList: bidderListEN,
        bidControl: bidControlEN,
        partnerInquiryManagement: partnerInquiryManagementEN,
        partnerInquiryManagementDownloadDoc: partnerInquiryManagementDownloadDocEN,
        partnerInquiryManagementParticipationConfirm: partnerInquiryManagementParticipationConfirmEN,
        mandatoryChecks: mandatoryChecksEN,
        offerSubmission: offerSubmissionEN,
        offerSubmissionSummary: offerSubmissionSummaryEN,
        activeTenderInternal: activeTenderInternalEN,
        bidResult: bidResultEN,
        generalStatusPR: generalStatusPREN,
        inquiryHeader: inquiryHeaderEN,
        purchaseOrder: purchaseOrderEN,
        negotiation: negotiationEN,
        detailTender: detailTenderEN,
        clarificationForm: clarificationFormEN,
        cbeManagementDrafting: cbeManagementDraftingEN,
        negotiationInternal: negotiationInternalEN,
        chat: chatEN,
        cbeManagementApproval: cbeManagementApprovalEN,
        negotiationBidderCase: negotiationBidderCaseEN,
        techOfferAdm: techOfferAdmEN,
        poList: poListEN,
        commOfferAdm: commOfferAdmEN,
        settingDoct: settingDoctEN,
        tbeManagement: tbeManagementEN,
        userManagement: userManagementEN,
        pageSetting: pageSettingEN,
        news: newsSettingEN,
        msProjectName: msProjectNameEN,
        createPoSca: createPoScaEN,
        listPoSca: listPoScaEN,
        partnerList: partnerListEN,
        vpe: vpeEN,
        masterDataRFQ: masterDataRFQEN,
        tenderHistory: tenderHistoryEN,
        faq:faqEN,
        localContent:locanContentEN
      },
      id: {
        login: LoginID,
        dashboard: dashboardID,
        navigation: navigationID,
        testTable: testTableID,
        register: registerID,
        generalInformation: generalInformationID,
        vendorHeader: vendorHeaderID,
        notifications: notificationsID,
        generalMessage: generalMessageID,
        companyDoc: companyID,
        qaQcQuestionnaire: qaQcQuestionnaireID,
        form: formID,
        financial: financialID,
        hseQuestionnaire: hseQuestionnaireID,
        partnerCandidate: partnerCandidateID,
        propertyPersonnel: propertyPersonnelID,
        bankDetails: bankDetailsID,
        additionalDocument: additionalDocumentID,
        experienceData: experienceDataID,
        scoring: scoringID,
        vmcfTab1: vmcfTab1ID,
        vmcfTab2: vmcfTab2ID,
        vmcfTab3: vmcfTab3ID,
        blastEmail: blastEmailID,
        expertiseQualification: expertiseQualificationID,
        vmcfTab4: vmcfTab4ID,
        declarations: declarationsID,
        invitationNewPartner: invitationNewPartnerID,
        applyExpertise: applyExpertiseID,
        recapitulationPQ: recapitulationPQID,
        expertiseQuestionnaireManagement: expertiseQuestionnaireManagementID,
        bidLineItems: bidLineItemsID,
        attachments: attachmentsID,
        table: tableID,
        bidTeams: bidTeamID,
        news: newsSettingID,
        bidderList: bidderListID,
        bidControl: bidControlID,
        partnerInquiryManagement: partnerInquiryManagementID,
        partnerInquiryManagementDownloadDoc: partnerInquiryManagementDownloadDocID,
        partnerInquiryManagementParticipationConfirm: partnerInquiryManagementParticipationConfirmID,
        mandatoryChecks: mandatoryChecksID,
        offerSubmission: offerSubmissionID,
        offerSubmissionSummary: offerSubmissionSummaryID,
        activeTenderInternal: activeTenderInternalID,
        bidResult: bidResultID,
        generalStatusPR: generalStatusPRID,
        inquiryHeader: inquiryHeaderID,
        purchaseOrder: purchaseOrderID,
        negotiation: negotiationID,
        detailTender: detailTenderID,
        clarificationForm: clarificationFormID,
        cbeManagementDrafting: cbeManagementDraftingID,
        negotiationInternal: negotiationInternalID,
        chat: chatID,
        cbeManagementApproval: cbeManagementApprovalID,
        negotiationBidderCase: negotiationBidderCaseID,
        techOfferAdm: techOfferAdmID,
        poList: poListID,
        commOfferAdm: commOfferAdmID,
        settingDoct: settingDoctID,
        tbeManagement: tbeManagementID,
        userManagement: userManagementID,
        pageSetting: pageSettingID,
        msProjectName: msProjectNameID,
        createPoSca: createPoScaID,
        listPoSca: listPoScaID,
        partnerList: partnerListID,
        vpe: vpeID,
        masterDataRFQ: masterDataRFQID,
        tenderHistory: tenderHistoryID,
        faq:faqID,
        localContent:locanContentID

      }
    },
    fallbackLng: "en",
    interpolation: { escapeValue: false }
  });

export default i18n;
